import { render, staticRenderFns } from "./vips.vue?vue&type=template&id=32a43f14&"
import script from "./vips.vue?vue&type=script&lang=ts&"
export * from "./vips.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports